import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { active: Boolean, url: String }

  connect() {
    if (this.activeValue) this.timer = setInterval(() => {
      if (!document.hidden && !this.element.hasAttribute("busy") && !this.element.contains(document.activeElement)) {
        if (this.element.src) this.element.reload()
        else this.element.src = this.urlValue
      }
    }, 5000)
  }

  disconnect() { clearInterval(this.timer) }

  loaded() {
    if (this.element.querySelector('[data-run-finished]')) clearInterval(this.timer)
  }
}
